import { render, staticRenderFns } from "./brandManage.vue?vue&type=template&id=1dfd8b8e&scoped=true"
import script from "./brandManage.vue?vue&type=script&lang=js"
export * from "./brandManage.vue?vue&type=script&lang=js"
import style0 from "./brandManage.vue?vue&type=style&index=0&id=1dfd8b8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfd8b8e",
  null
  
)

export default component.exports